export const TransformIndicatorData = (indicatorId: number, data: any[], metadata: any[], fromYearVal: number, toYearVal: number) => {

    let transformedData: Array<any> = [];
    const provinces = ['Attapeu', 'Bokeo', 'Bolikhamxai', 'Champasak', 'Houaphanh', 'Khammouane',
        'Luang Namtha', 'Luang Prabang', 'Oudomxay', 'Phongsaly', 'Salavan', 'Savannakhet',
        'Sekong', 'Vientiane', 'Vientiane Capital', 'Xaisomboun', 'Xayabouly', 'Xiangkhouang'
    ];

    switch (indicatorId) {
        // Number of Skills Development and Employment
        case 9:
            {
                //for (let index = 0; index < 24; index++) {
                for (let index = 0; index < metadata.length; index++) {
                    transformedData.push({
                        'category_id': metadata[index].id,
                        'index': index,
                        // 'sr_no': GetSerialNumber(index),
                        // 'category': GetCategoryName(index),
                        // 'subcategory': GetSubCategoryName(index),
                        'sr_no': metadata[index].sr_no,
                        'category': metadata[index].cat_level1,
                        'subcategory': metadata[index].cat_level2,
                        '1_total': null,
                        '1_female': null,
                        '2_total': null,
                        '2_female': null,
                        '3_total': null,
                        '3_female': null,
                        '4_total': null,
                        '4_female': null,
                        '5_total': null,
                        '5_female': null,
                        '6_total': null,
                        '6_female': null,
                        '7_total': null,
                        '7_female': null,
                        '8_total': null,
                        '8_female': null,
                        '9_total': null,
                        '9_female': null,
                        '10_total': null,
                        '10_female': null,
                        'tot_total': null,
                        'tot_female': null,
                    });
                }

                const GetYearNumber = (dataItem: any) => {
                    let yearDiff: number = dataItem.year - fromYearVal;
                    return yearDiff + 1;
                }

                if (data) {
                    data.forEach((dataItem: any) => {
                        const totalColumnName = `${GetYearNumber(dataItem)}_total`;
                        const femaleColumnName = `${GetYearNumber(dataItem)}_female`;

                        var transformedDataItemIndex = transformedData.findIndex((transformedDataItem: any) => transformedDataItem['category_id'] === dataItem['category_id']);

                        if (transformedDataItemIndex !== -1) {
                            transformedData[transformedDataItemIndex][totalColumnName] = dataItem['total'];
                            transformedData[transformedDataItemIndex][femaleColumnName] = dataItem['female'];

                            transformedData[transformedDataItemIndex + 1][totalColumnName] = dataItem['agriculture_total'];
                            transformedData[transformedDataItemIndex + 1][femaleColumnName] = dataItem['agriculture_female'];

                            transformedData[transformedDataItemIndex + 2][totalColumnName] = dataItem['service_total'];
                            transformedData[transformedDataItemIndex + 2][femaleColumnName] = dataItem['service_female'];

                            transformedData[transformedDataItemIndex + 3][totalColumnName] = dataItem['industry_total'];
                            transformedData[transformedDataItemIndex + 3][femaleColumnName] = dataItem['industry_female'];
                        }
                    });



                    transformedData.forEach((dataItem: any) => {
                        let multiple_year_total: number = 0;
                        let multiple_year_female: number = 0;
                        for (let columIndex = 1; columIndex <= 5; columIndex++) {

                            dataItem[`${columIndex}_total`] = dataItem[`${columIndex}_total`] == null ? 0 : dataItem[`${columIndex}_total`];
                            multiple_year_total += dataItem[`${columIndex}_total`];
                            dataItem[`${columIndex}_female`] = dataItem[`${columIndex}_female`] == null ? 0 : dataItem[`${columIndex}_female`];
                            multiple_year_female += dataItem[`${columIndex}_female`];
                        }

                        dataItem['tot_total'] = multiple_year_total;
                        dataItem['tot_female'] = multiple_year_female;

                    });
                }
            }
            break;
        case 14:
            {
                for (let index = 0; index < metadata.length; index++) {
                    transformedData.push({
                        'category_id': metadata[index].id,
                        'index': index,
                        // 'sr_no': GetSerialNumber(index),
                        // 'category': GetCategoryName(index),
                        // 'subcategory': GetSubCategoryName(index),
                        'sr_no': metadata[index].sr_no,
                        'category': metadata[index].cat_level1,
                        'subcategory': metadata[index].cat_level2,
                        '1_total': null,
                        '1_female': null,
                        '2_total': null,
                        '2_female': null,
                        '3_total': null,
                        '3_female': null,
                        '4_total': null,
                        '4_female': null,
                        '5_total': null,
                        '5_female': null,
                        'tot_total': null,
                        'tot_female': null,
                    });
                }

                const GetYearNumber = (dataItem: any) => {
                    if (dataItem && dataItem.period) {
                        let period: string = dataItem.period;
                        let year = parseInt(period.split('-')[0]);
                        let yearDiff: number = year - fromYearVal;
                        return yearDiff + 1;
                    }
                    return 1;
                }

                if (data) {
                    data.forEach((dataItem: any) => {
                        const totalColumnName = `${GetYearNumber(dataItem)}_total`;
                        const femaleColumnName = `${GetYearNumber(dataItem)}_female`;

                        var transformedDataItemIndex = transformedData.findIndex((transformedDataItem: any) => transformedDataItem['category_id'] === dataItem['category_id']);

                        if (transformedDataItemIndex !== -1) {
                            transformedData[transformedDataItemIndex][totalColumnName] = dataItem['total'];
                            transformedData[transformedDataItemIndex][femaleColumnName] = dataItem['female'];

                            transformedData[transformedDataItemIndex + 1][totalColumnName] = dataItem['agriculture_total'];
                            transformedData[transformedDataItemIndex + 1][femaleColumnName] = dataItem['agriculture_female'];

                            transformedData[transformedDataItemIndex + 2][totalColumnName] = dataItem['service_total'];
                            transformedData[transformedDataItemIndex + 2][femaleColumnName] = dataItem['service_female'];

                            transformedData[transformedDataItemIndex + 3][totalColumnName] = dataItem['industry_total'];
                            transformedData[transformedDataItemIndex + 3][femaleColumnName] = dataItem['industry_female'];
                        }
                    });

                    transformedData.forEach((dataItem: any) => {
                        let multiple_year_total: number = 0;
                        let multiple_year_female: number = 0;
                        for (let columIndex = 1; columIndex <= 5; columIndex++) {

                            dataItem[`${columIndex}_total`] = dataItem[`${columIndex}_total`] == null ? 0 : dataItem[`${columIndex}_total`];
                            multiple_year_total += dataItem[`${columIndex}_total`];
                            dataItem[`${columIndex}_female`] = dataItem[`${columIndex}_female`] == null ? 0 : dataItem[`${columIndex}_female`];
                            multiple_year_female += dataItem[`${columIndex}_female`];
                        }

                        dataItem['tot_total'] = multiple_year_total;
                        dataItem['tot_female'] = multiple_year_female;

                    });
                }
            }
            break;
        case 11:
            {
                const allYears = Array.from({ length: toYearVal - fromYearVal + 1 }, (_, i) => fromYearVal + i); // Generate all years in range
                // Fill missing years with default objects
                allYears.forEach((year) => {
                    const existingData = data.find((item) => item.year === year);
                    if (existingData) {
                        transformedData.push(existingData); // Use existing data if present
                    } else {
                        transformedData.push({
                            batch_id: 0,
                            business_ent: 0,
                            business_exit: 0,
                            children_ent: 0,
                            children_exit: 0,
                            created_at: new Date(),
                            diplomatic_ent: 0,
                            diplomatic_exit: 0,
                            female_ent: 0,
                            female_exit: 0,
                            id: year,
                            is_active: 1,
                            male_ent: 0,
                            male_exit: 0,
                            node_id: 0,
                            official_ent: 0,
                            official_exit: 0,
                            total_ent: 0,
                            total_exit: 0,
                            tourism_ent: 0,
                            tourism_exit: 0,
                            transit_ent: 0,
                            transit_exit: 0,
                            visit_ent: 0,
                            year: year,
                        });
                    }
                });
            }
            break;
        case 13:
            {
                transformedData = data && data.length > 0 ? data : [];

                if (transformedData.length > 0) {
                    transformedData.forEach((transformedDataItem) => {
                        const province = metadata.find((x) => x.id === transformedDataItem.province_id);
                        if (province) {
                            transformedDataItem['province_name'] = province.name;
                            transformedDataItem['province_code'] = province.province_code;

                        }
                    })
                }
                else {

                    for (let index = 1; index < metadata.length + 1; index++) {
                        transformedData.push({
                            province_id: 0,
                            batch_id: 0,
                            birth_reg_under_5_years_age_female: 0,
                            birth_reg_under_5_years_age_total: 0,
                            birth_reg_upper_5_years_age_total: 0,
                            birth_reg_upper_5_years_of_age_female: 0,
                            birth_reg_within_a_year_female: 0,
                            birth_reg_within_a_year_total: 0,
                            created_at: new Date(),
                            death_reg_lower_5_years_female: 0,
                            death_reg_lower_5_years_total: 0,
                            death_reg_over_5_years_female: 0,
                            death_reg_over_5_years_total: 0,
                            divorce_reg_lao_Alien: 0,
                            divorce_reg_lao_foreigner: 0,
                            divorce_reg_lao_lao: 0,
                            divorce_reg_lao_stateless_person: 0,
                            id: index,
                            is_active: 1,
                            marriage_reg_lao_alien: 0,
                            marriage_reg_lao_foreigner: 0,
                            marriage_reg_lao_lao: 0,
                            marriage_reg_lao_stateless_person: 0,
                            move_in_reg_district_district_female: 0,
                            move_in_reg_district_district_total: 0,
                            move_in_reg_province_province_female: 0,
                            move_in_reg_province_province_total: 0,
                            move_in_reg_total_female: 0,
                            move_in_reg_total_total: 0,
                            move_in_reg_village_village_female: 0,
                            move_in_reg_village_village_total: 0,
                            move_out_reg_district_district_female: 0,
                            move_out_reg_district_district_total: 0,
                            move_out_reg_province_province_female: 0,
                            move_out_reg_province_province_total: 0,
                            move_out_reg_total_female: 0,
                            move_out_reg_total_total: 0,
                            move_out_reg_village_village_female: 0,
                            move_out_reg_village_village_total: 0,
                            node_id: 0,
                            province_name: metadata[index - 1]['name'],
                            province_code: metadata[index - 1]['code'],
                            reg_change_of_name_female: 0,
                            reg_change_of_name_total: 0,
                            reg_change_of_national_lao_citizen_abandonment_female: 0,
                            reg_change_of_national_lao_citizen_abandonment_total: 0,
                            reg_change_of_national_lao_citizen_granting_female: 0,
                            reg_change_of_national_lao_citizen_granting_total: 0,
                            reg_change_of_national_lao_citizen_restoration_female: 0,
                            reg_change_of_national_lao_citizen_restoration_total: 0,
                            reg_change_of_national_lao_citizen_revocation_female: 0,
                            reg_change_of_national_lao_citizen_revocation_total: 0,
                            reg_change_of_national_total_female: 0,
                            reg_change_of_national_total_total: 0,
                            reg_change_of_surname_female: 0,
                            reg_change_of_surname_total: 0,
                            year: fromYearVal
                        });
                    }
                }
            }
            break;
        case 15:
            {
                const allYears = Array.from({ length: toYearVal - fromYearVal + 1 }, (_, i) => fromYearVal + i); // Generate all years in range
                // Fill missing years with default objects
                allYears.forEach((year) => {
                    const existingData = data.find((item) => item.year === year);
                    if (existingData) {
                        transformedData.push(existingData); // Use existing data if present
                    } else {
                        transformedData.push({
                            batch_id: 0,
                            business_ent: 0,
                            business_exit: 0,
                            children_ent: 0,
                            children_exit: 0,
                            created_at: new Date(),
                            diplomatic_ent: 0,
                            diplomatic_exit: 0,
                            female_ent: 0,
                            female_exit: 0,
                            id: year,
                            is_active: 1,
                            male_ent: 0,
                            male_exit: 0,
                            node_id: 0,
                            official_ent: 0,
                            official_exit: 0,
                            total_ent: 0,
                            total_exit: 0,
                            tourism_ent: 0,
                            tourism_exit: 0,
                            transit_ent: 0,
                            transit_exit: 0,
                            visit_ent: 0,
                            visit_exit: 0,
                            year: year
                        });
                    }
                });


            }
            break;
        case 16:
            {
                transformedData = data && data.length > 0 ? data : [];

                if (transformedData.length > 0) {
                    transformedData.forEach((transformedDataItem) => {
                        const province = metadata.find((x) => x.id === transformedDataItem.province_id);
                        if (province) {
                            transformedDataItem['province_name'] = province.name;
                            transformedDataItem['province_code'] = province.province_code;

                        }
                    })
                }
                else {

                    for (let index = 1; index < provinces.length + 1; index++) {
                        const province = metadata.find((x) => x.id === index);
                        transformedData.push({
                            Birth_notification_female: 0,
                            Birth_notification_total: 0,
                            batch_id: 0,
                            created_at: new Date(),
                            death_notification_Lower_5_years_female: 0,
                            death_notification_Lower_5_years_total: 0,
                            death_notification_Over_5_years_female: 0,
                            death_notification_Over_5_years_total: 0,
                            death_notification_total_female: 0,
                            death_notification_total_total: 0,
                            id: index,
                            is_active: 1,
                            married_proposal_under_18_year_lao_stateless_person: 0,
                            married_proposal_under_18_years_lao_alien: 0,
                            married_proposal_under_18_years_lao_foreigner: 0,
                            married_proposal_under_18_years_old_lao_lao: 0,
                            married_proposal_upper_18_years_old_lao_alln: 0,
                            married_proposal_upper_18_years_old_lao_foreigner: 0,
                            married_proposal_upper_18_years_old_lao_lao: 0,
                            married_proposal_upper_18_years_old_lao_stateless_person: 0,
                            move_in_request_Province_Province_female: 0,
                            move_in_request_Province_Province_total: 0,
                            move_in_request_district_district_female: 0,
                            move_in_request_district_district_total: 0,
                            move_in_request_total_female: 0,
                            move_in_request_total_total: 0,
                            move_in_request_village_village_female: 0,
                            move_in_request_village_village_total: 0,
                            move_out_request_Province_Province_female: 0,
                            move_out_request_Province_Province_total: 0,
                            move_out_request_district_district_female: 0,
                            move_out_request_district_district_total: 0,
                            move_out_request_total_female: 0,
                            move_out_request_total_total: 0,
                            move_out_request_village_village_female: 0,
                            move_out_request_village_village_total: 0,
                            node_id: 0,
                            num_laos_population_in_2022_female: 0,
                            num_laos_population_in_2022_total: 0,
                            num_of_district_total: 0,
                            num_of_family_total: 0,
                            num_of_unit_total: 0,
                            num_of_village_total: 0,
                            province_name: province.name,
                            province_code: province.code,
                            reg_change_name_female: 0,
                            reg_change_name_total: 0,
                            reg_change_surname_female: 0,
                            reg_change_surname_total: 0,
                            total_lao_population_female: 0,
                            total_lao_population_total: 0,
                            uncontested_divorce_Lao_Alien: 0,
                            uncontested_divorce_Lao_Foreigner: 0,
                            uncontested_divorce_Lao_Lao: 0,
                            uncontested_divorce_Lao_Stateless_person: 0,
                            year: fromYearVal
                        });
                    }
                }
            }
            break;
        default:
            {
                transformedData = data;
            }
            break;
    }
    return transformedData;
}